import React from 'react';
import css from './SaveNewTagButton.module.scss';

interface SaveNewTagButtonProps {
    onClick: () => void;
    disabled?: boolean;
    text?: string;
}

export const SaveNewTagButton: React.FC<SaveNewTagButtonProps> = ({
	onClick,
	disabled = false,
	text,
}) => (
	<button
		type="button"
		className={css.button}
		onClick={onClick}
		disabled={disabled}
	>
		{text}
	</button>
);

export default SaveNewTagButton;
